export default __webpack_public_path__ + "static/media/rotate_left.97d58c90.svg";